"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { MemesSingleWaveDropInfoPanel } from "./MemesSingleWaveDropInfoPanel";
import { SingleWaveDropWrapper } from "./SingleWaveDropWrapper";
import { useSingleWaveDropData } from "./useSingleWaveDropData";
interface MemesSingleWaveDropProps {
  readonly drop: ExtendedDrop;
  readonly onClose: () => void;
}
export const MemesSingleWaveDrop: React.FC<MemesSingleWaveDropProps> = t0 => {
  const $ = _c(9);
  const {
    drop: initialDrop,
    onClose
  } = t0;
  const {
    drop,
    wave,
    extendedDrop
  } = useSingleWaveDropData(initialDrop, onClose);
  if (!extendedDrop || !wave || !drop) {
    return null;
  }
  let t1;
  if ($[0] !== extendedDrop || $[1] !== onClose || $[2] !== wave) {
    t1 = <MemesSingleWaveDropInfoPanel drop={extendedDrop} wave={wave} onClose={onClose} />;
    $[0] = extendedDrop;
    $[1] = onClose;
    $[2] = wave;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== drop || $[5] !== onClose || $[6] !== t1 || $[7] !== wave) {
    t2 = <SingleWaveDropWrapper drop={drop} wave={wave} onClose={onClose}>{t1}</SingleWaveDropWrapper>;
    $[4] = drop;
    $[5] = onClose;
    $[6] = t1;
    $[7] = wave;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};